import { requiresMfa } from '../members/roles';

/** Destino después de aceptar: segundo factor si el rol lo exige, terreno para Vendedor y consola para el resto. */
export function nextPathAfterAccept(role: string, hasSecondFactor: boolean): string {
  if (requiresMfa(role) && !hasSecondFactor) return '/login/segundo-factor';
  return role === 'seller' ? '/terreno' : '/consola';
}
